
const newModel = () => {
    return {
        truongMamnonPhonghocId: null,
        truongMamnonId: null,
        tenTruongMamnon: null,
        idKy: null,
        tenKy: null,
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,
        ghiChu: null,
        enabled: true,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongMamnonPhonghocId: null,
        truongMamnonId: null,
        idKy: null,
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        truongMamnonPhonghocId: item.truongMamnonPhonghocId,
        truongMamnonId: item.truongMamnonId,
        tenTruongMamnon: item.tenTruongMamnon,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongMamnonPhonghocId: item.truongMamnonPhonghocId,
        truongMamnonId: item.truongMamnonId,
        tenTruongMamnon: item.tenTruongMamnon,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongMamnonId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongMamnonId: item.truongMamnonId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongMamnonPhonghocId: null,
        truongMamnonId: null,
        idKy: null,
        tongsoPhong: null,
        phongKienco: null,
        phongBankienco: null,
        phongTam: null,
        ghiChu: null,
        enabled: null,
    }
}

export const truongMamnonPhonghocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


